import { BaseViewStore } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';

class SearchFilterStore extends BaseViewStore {
	@observable searchTerm = '';

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.queryUtility = componentProps.queryUtility;
		this.searchTerm = this.queryUtility.filter.search === null ? '' : this.queryUtility.filter.search;
		this.activeView = rootStore[rootStore.activeView];
	}

	@action.bound
	onValueChange = async e => {
		this.searchTerm = e.target.value;
	};

	@action.bound
	onCheck = async (event, statusId) => {
		_.each(this.fulfillmentOrderStatuses, status => {
			if (status.statusId === statusId) {
				status.state = event.currentTarget.checked;
			}
		});
	};

	@action.bound
	onKeyPress = e => {
		if (e.key === 'Enter') {
			this.searchForTerm();
		}
	};

	@action.bound
	clearSearchField = () => {
		this.searchTerm = null;
		if (this.queryUtility.filter.search) {
			this.clearSearchFilterAndRefreshData();
		}
	};

	@action.bound
	searchForTerm = () => {
		if (this.activeView && this.activeView.tableFilter) {
			this.activeView.tableFilter.removeAll(false);
		}
		if (this.activeView && this.activeView.orderDateRangeViewStore){
			this.activeView.orderDateRangeViewStore.resetFilter(true, true);
		}
		if (this.searchTerm !== null && this.searchTerm.trim() !== '') {
			this.searchTerm = this.searchTerm.trim();
			this.queryUtility.filter.search = this.searchTerm.trim();
			this.queryUtility.fetch();
		}
	};

	@action.bound
	clearSearchFilterAndRefreshData = () => {
		this.queryUtility.filter.search = null;
		if (this.activeView && this.activeView.orderDateRangeViewStore){
			this.activeView.orderDateRangeViewStore.resetFilter(false, false);
		}
		this.queryUtility.fetch();
	};
}

export default SearchFilterStore;



// WEBPACK FOOTER //
// ./src/core/components/search-filter/SearchFilterStore.js